import script from "./Circles.vue?vue&type=script&lang=ts"
export * from "./Circles.vue?vue&type=script&lang=ts"

export default script